<form [formGroup]='userForm' (ngSubmit)='onSubmit(userForm)'>
  <div formArrayName="emails">
    <div *ngFor='let item of formData.controls; let i=index'>
      <div [formGroupName]="i">
        <input type="text" placeholder="Enter Email" name="firstName" id="firstName" formControlName="email">
      </div>
    </div>
  </div>
  <div class="bmw-user-notifs-add-another pointer" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true")? "#281432" : "#1c69d4"}' (click)='addNewEmail()'>Add another</div>
  <textarea class="bmw-share-textarea" type="text" placeholder="Enter email body here..." id="body" formControlName="body"></textarea>
  <button type="submit" [disabled]="userForm.invalid" [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true")? "#281432" : "#1c69d4"}' class="bmw-submit-button pointer">Send</button>
</form>